import { Injectable } from '@angular/core';
import { Fetcher } from '../../http/fetcher';
import type { TeamGroup } from './team-group';

@Injectable({
    providedIn: 'root',
})
export class TeamGroupFetcher extends Fetcher<TeamGroup> {
    readonly modelName = 'Team Group';

    get resourceName(): string {
        return 'team-groups';
    }
}
